var _circle, _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStretch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 63,
    viewBox: "0 0 52 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.07,
    cx: 25.7301,
    cy: 25.7301,
    r: 25.7301,
    fill: "#7A208E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M51.4602 25.7299C51.4602 39.9402 39.9405 51.46 25.7301 51.46C11.5198 51.46 0 39.9402 0 25.7299C0 25.7299 8.20336 30.024 16.3737 29.2386C23.3096 28.5718 28.0692 23.9756 38.0104 23.3908C47.9516 22.806 51.4602 25.7299 51.4602 25.7299Z",
    fill: "#673AB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M51.4602 25.7301C51.4602 39.9405 39.9405 51.4603 25.7301 51.4603C11.5198 51.4603 0 39.9405 0 25.7301C0 25.7301 5.26298 22.2215 14.6194 23.391C21.6367 24.5606 26.3149 27.4845 36.2561 26.8997C46.1972 26.3149 51.4602 25.7301 51.4602 25.7301Z",
    fill: "#9D27B0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0207 14.0803H42.8646C44.7987 13.2213 45.3006 12.4396 45.6798 10.7803H7.83105C8.12375 12.4233 8.56339 13.1698 10.0207 14.0803Z",
    fill: "#FFE0B2",
    stroke: "#651E7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9889 35.8652C17 30.5 19 28 22.3113 23.666C22.5847 28.0027 23.5775 29.1878 26.6905 29.2964C20.8356 33.2752 17.6314 36.0527 11.9889 41.4956C10.6327 39.3893 10.6001 38.1589 11.9889 35.8652Z",
    fill: "#673AB7",
    stroke: "#57196D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4704 10.7803H32.352C32.4442 12.1674 32.8293 13.8386 33.916 14.9083L31.916 23.3539L28.4752 23.6667C32.6485 23.6277 34.9349 23.6792 38.172 24.9179C39.5959 25.9309 39.8049 26.6499 39.736 28.0459L36.608 41.4963C34.4473 40.97 33.8436 40.0659 33.48 37.7427L35.044 29.2971H25.9728C23.2299 28.6563 22.5785 27.7242 22.2192 25.5435L20.2192 14.9083C21.1329 13.9546 21.5147 12.3372 21.4704 10.7803Z",
    fill: "#9D27B0",
    stroke: "#57196D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3528 6.57958C30.3528 8.54467 28.8123 11.7799 26.912 11.7799C25.0117 11.7799 23.4712 8.54467 23.4712 6.57958C23.4712 4.6145 25.0117 3.02148 26.912 3.02148C28.8123 3.02148 30.3528 4.6145 30.3528 6.57958Z",
    fill: "#FFE0B2",
    stroke: "#651E7E",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_563_4650)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.1707,
    cy: 52.0194,
    rx: 12.8651,
    ry: 2.79675,
    fill: "#771387"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_563_4650",
    x: 4.30566,
    y: 41.2227,
    width: 41.73,
    height: 21.5938,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_563_4650"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStretch);
export default __webpack_public_path__ + "static/media/Stretch.50bb655aca3bc2b2dccd5f95399e3f8c.svg";
export { ForwardRef as ReactComponent };